export const ComponentClassObject = {
  Alert: {
    className: 'amplify-alert',
    components: ['Alert'],
    description: 'Top level element that wraps the Alert primitive',
  },
  AlertIcon: {
    className: 'amplify-alert__icon',
    components: ['Alert'],
    description: 'Class applied to Icon component within the Alert primitive',
  },
  AlertHeading: {
    className: 'amplify-alert__heading',
    components: ['Alert'],
    description: 'Class applied to the heading View',
  },
  AlertBody: {
    className: 'amplify-alert__body',
    components: ['Alert'],
    description: 'Class applied to the body View',
  },
  AlertDismiss: {
    className: 'amplify-alert__dismiss',
    components: ['Alert'],
    description: 'Class applied to the close Button',
  },
  Badge: {
    className: 'amplify-badge',
    components: ['Badge'],
    description: 'Top level element that wraps the Badge component',
  },
  Button: {
    className: 'amplify-button',
    components: ['Button'],
    description: 'Top level element that wraps the Button primitive',
  },
  ButtonGroup: { className: 'amplify-buttongroup' },
  ButtonLoaderWrapper: {
    className: 'amplify-button__loader-wrapper',
    components: ['Button'],
    description:
      'Class applied to the Loader component within the Button Loading state',
  },
  Card: {
    className: 'amplify-card',
    components: ['Card'],
    description: 'Top level element that wraps the Card primitive',
  },
  Checkbox: {
    className: 'amplify-checkbox',
    components: ['Checkbox'],
    description: 'Top level element that wraps the Checkbox primitive',
  },
  CheckboxButton: {
    className: 'amplify-checkbox__button',
    components: ['Checkbox'],
    description: 'Wrapper for the checked icon within the Checkbox primitive',
  },
  CheckboxIcon: {
    className: 'amplify-checkbox__icon',
    components: ['Checkbox'],
    description:
      'Class applied to the checked icon within the Checkbox primitive',
  },
  CheckboxInput: {
    className: 'amplify-checkbox__input',
    components: ['Checkbox'],
    description:
      'Class applied to the visually hidden checkbox input within the Checkbox primitive',
  },
  CheckboxLabel: {
    className: 'amplify-checkbox__label',
    components: ['Checkbox'],
    description: 'Class applied to the label within the Checkbox primitive',
  },
  CheckboxField: {
    className: 'amplify-checkboxfield',
    components: ['CheckboxField'],
    description: 'Top level element that wraps the CheckboxField primitive',
  },
  Collection: {
    className: 'amplify-collection',
    components: ['Collection'],
    description: 'Top level element that wraps the Collection primitive',
  },
  CollectionItems: {
    className: 'amplify-collection-items',
    components: ['Collection'],
    description:
      'Class applied to the element that wraps all the items in a collection',
  },
  CollectionSearch: {
    className: 'amplify-collection-search',
    components: ['Collection'],
    description:
      'Class applied to the element that wraps the collection search box',
  },
  CollectionPagination: {
    className: 'amplify-collection-pagination',
    components: ['Collection'],
    description:
      'Class applied to the element that wraps the pagination component in a collection',
  },
  CountryCodeSelect: {
    className: 'amplify-countrycodeselect',
    components: ['PhoneNumberField'],
    description:
      'Class applied to the Country Code Select within the PhoneNumberField primitive',
  },
  Divider: {
    className: 'amplify-divider',
    components: ['Divider'],
    description: 'Top level element that wraps the Divider primitive',
  },
  DividerLabel: {
    className: 'amplify-divider--label',
    components: ['Divider'],
    description: 'Class applied to the label of the Divider component',
  },
  Expander: {
    className: 'amplify-expander',
    components: ['Expander'],
    description: 'Top level element that wraps the Expander primitive',
  },
  ExpanderContent: {
    className: 'amplify-expander__content',
    components: ['Expander'],
    description: 'Expander content container',
  },
  ExpanderContentText: {
    className: 'amplify-expander__content__text',
    components: ['Expander'],
    description: 'Expander content text',
  },
  ExpanderHeader: {
    className: 'amplify-expander__header',
    components: ['Expander'],
    description: 'Expander item header',
  },
  ExpanderIcon: {
    className: 'amplify-expander__icon',
    components: ['Expander'],
    description: 'Icon to indicate whether an item is expanded or collapsed',
  },
  ExpanderItem: {
    className: 'amplify-expander__item',
    components: ['Expander'],
    description: 'Expander item(containier for header, trigger, and content)',
  },
  ExpanderTrigger: {
    className: 'amplify-expander__trigger',
    components: ['Expander'],
    description: 'Expander item trigger(button)',
  },
  Field: { className: 'amplify-field' },
  FieldDescription: { className: 'amplify-field__description' },
  FieldErrorMessage: { className: 'amplify-field__error-message' },
  FieldGroup: { className: 'amplify-field-group' },
  FieldGroupControl: { className: 'amplify-field-group__control' },
  FieldGroupOuterEnd: { className: 'amplify-field-group__outer-end' },
  FieldGroupOuterStart: { className: 'amplify-field-group__outer-start' },
  FieldGroupInnerEnd: { className: 'amplify-field-group__inner-end' },
  FieldGroupInnerStart: { className: 'amplify-field-group__inner-start' },
  FieldGroupIcon: { className: 'amplify-field-group__icon' },
  FieldGroupIconButton: { className: 'amplify-field-group__icon-button' },
  FieldGroupHasInnerEnd: { className: 'amplify-field-group--has-inner-end' },
  FieldGroupHasInnerStart: {
    className: 'amplify-field-group--has-inner-start',
  },
  FieldShowPassword: { className: 'amplify-field__show-password' },
  FieldGroupFieldWrapper: { className: 'amplify-field-group__field-wrapper' },
  Flex: {
    className: 'amplify-flex',
    components: ['Flex'],
    description: 'Top level element that wraps the Flex primitive',
  },
  Grid: {
    className: 'amplify-grid',
    components: ['Grid'],
    description: 'Top level element that wraps the Grid primitive',
  },
  Heading: {
    className: 'amplify-heading',
    components: ['Heading'],
    description: 'Top level element that wraps the Heading primitive',
  },
  Icon: {
    className: 'amplify-icon',
    components: ['Icon'],
    description: 'Top level element that wraps the Icon primitive',
  },
  Image: {
    className: 'amplify-image',
    components: ['Image'],
    description: 'Top level element that wraps the Image primitive',
  },
  Input: { className: 'amplify-input' },
  Label: { className: 'amplify-label' },
  Link: {
    className: 'amplify-link',
    components: ['Link'],
    description: 'Top level element that wraps the Link primitive',
  },
  Loader: {
    className: 'amplify-loader',
    components: ['Loader'],
    description: 'Top level element that wraps the Loader primitive',
  },
  MenuContent: {
    className: 'amplify-menu-content',
    components: ['Menu'],
    description: 'Menu content container (Flex)',
  },
  MenuItem: {
    className: 'amplify-menu-content__item',
    components: ['Menu'],
    description:
      'Menu item button (MenuButton, wrapped in amplify-menu-content class)',
  },
  MenuTrigger: {
    className: 'amplify-menu-trigger',
    components: ['Menu'],
    description:
      'Menu trigger button (MenuButton, not wrapped in amplify-menu-content class)',
  },
  Pagination: {
    className: 'amplify-pagination',
    components: ['Pagination'],
    description: 'Top level element that wraps the Pagination primitive',
  },
  PaginationItemButton: {
    className: 'amplify-pagination__item-button',
    components: ['Pagination'],
    description: 'Class applied to the pagination buttons',
  },
  PaginationItemCurrent: {
    className: 'amplify-pagination__item-current',
    components: ['Pagination'],
    description: 'Class applied to the currently selected pagination button',
  },
  PaginationItemEllipsis: {
    className: 'amplify-pagination__item-ellipsis',
    components: ['Pagination'],
    description:
      'Class applied to the ellipsis within the Pagination primitive',
  },
  PasswordField: {
    className: 'amplify-passwordfield',
    components: ['PasswordField'],
    description: 'Top level element that wraps the PasswordField primitive',
  },
  PhoneNumberField: {
    className: 'amplify-phonenumberfield',
    components: ['PhoneNumberField'],
    description: 'Top level element that wraps the PhoneNumberField primitive',
  },
  Placeholder: {
    className: 'amplify-placeholder',
    components: ['Placeholder'],
    description: 'Top level element that wraps the Placeholder primitive',
  },
  Radio: {
    className: 'amplify-radio',
    components: ['RadioGroupField', 'Radio'],
    description: 'Top level element that wraps the Radio primitive',
  },
  RadioButton: {
    className: 'amplify-radio__button',
    compoents: ['RadioGroupField', 'Radio'],
    description: 'Class applied to the displayed radio button',
  },
  RadioInput: {
    className: 'amplify-radio__input',
    components: ['RadioGroupField', 'Radio'],
    description: 'Class applied to the visually hidden radio input',
  },
  RadioLabel: {
    className: 'amplify-radio__label',
    components: ['RadioGroupField', 'Radio'],
    description: 'Class applied to the radio label',
  },
  RadioGroupField: {
    className: 'amplify-radiogroupfield',
    components: ['RadioGroupField'],
    description: 'Top level element that wraps the RadioGroupField primitive',
  },
  RadioGroup: {
    className: 'amplify-radiogroup',
    components: ['RadioGroupField'],
    description: 'Class applied to the radio group wrapper',
  },
  Rating: {
    className: 'amplify-rating',
    components: ['Rating'],
    description: 'Top level element that wraps the Rating primitive',
  },
  ScrollView: {
    className: 'amplify-scrollview',
    components: ['ScrollView'],
    description: 'Top level element that wraps the ScrollView primitive',
  },
  SearchField: {
    className: 'amplify-searchfield',
    components: ['SearchField'],
    description: 'Top level element that wraps the SearchField primitive',
  },
  SearchFieldClear: {
    className: 'amplify-searchfield__clear',
    components: ['SearchField'],
    description: 'Class applied to the search field clear button',
  },
  SearchFieldSearch: {
    className: 'amplify-searchfield__search',
    components: ['SearchField'],
    description: 'Class applied to the search button',
  },
  Select: {
    className: 'amplify-select',
    components: ['Select', 'SelectField'],
    description: 'Class applied to the select element',
  },
  SelectField: {
    className: 'amplify-selectfield',
    components: ['SelectField'],
    description: 'Top level element that wraps the SelectField primitive',
  },
  SelectWrapper: {
    className: 'amplify-select__wrapper',
    components: ['Select', 'SelectField'],
    description: 'Class applied to the select wrapper',
  },
  SelectIconWrapper: {
    className: 'amplify-select__icon-wrapper',
    components: ['Select', 'SelectField'],
    description: 'Class applied to the select icon wrapper',
  },
  SliderField: {
    className: 'amplify-sliderfield',
    components: ['SliderField'],
    description: 'Top level element that wraps the SliderField primitive',
  },
  SliderFieldGroup: {
    className: 'amplify-sliderfield__group',
    components: ['SliderField'],
    description: 'Class applied to the element that wraps the slider root',
  },
  SliderFieldLabel: {
    className: 'amplify-sliderfield__label',
    components: ['SliderField'],
    description: 'Class applied to the slider label',
  },
  SliderFieldRange: {
    className: 'amplify-sliderfield__range',
    components: ['SliderField'],
    description: 'Class applied to the filled in portion of the slider track',
  },
  SliderFieldRoot: {
    className: 'amplify-sliderfield__root',
    components: ['SliderField'],
    description:
      'Class applied to the slider root which wraps the track and thumb',
  },
  SliderFieldThumb: {
    className: 'amplify-sliderfield__thumb',
    components: ['SliderField'],
    description: 'Class applied to the slider thumb',
  },
  SliderFieldTrack: {
    className: 'amplify-sliderfield__track',
    components: ['SliderField'],
    description: 'Class applied to the slider track',
  },
  StepperField: {
    className: 'amplify-stepperfield',
    components: ['StepperField'],
    description: 'Top level element that wraps the StepperField primitive',
  },
  StepperFieldButtonDecrease: {
    className: 'amplify-stepperfield__button--decrease',
    components: ['StepperField'],
    description: 'Class applied to the decrease button',
  },
  StepperFieldButtonIncrease: {
    className: 'amplify-stepperfield__button--increase',
    components: ['StepperField'],
    description: 'Class applied to the increase button',
  },
  StepperFieldInput: {
    className: 'amplify-stepperfield__input',
    components: ['StepperField'],
    description: 'Class applied to the StepperField input',
  },
  SwitchField: {
    className: 'amplify-switchfield',
    components: ['SwitchField'],
    description: 'Top level element that wraps the SwitchField primitive',
  },
  SwitchLabel: {
    className: 'amplify-switch-label',
    components: ['SwitchField'],
    description: 'Class applied to the SwitchField label text',
  },
  SwitchThumb: {
    className: 'amplify-switch-thumb',
    components: ['SwitchField'],
    description: 'Class applied to the SwitchField thumb',
  },
  SwitchTrack: {
    className: 'amplify-switch-track',
    components: ['SwitchField'],
    description: 'Class applied to the SwitchField track',
  },
  SwitchWrapper: {
    className: 'amplify-switch__wrapper',
    components: ['SwitchField'],
    description:
      'Class applied to the label element that wraps the SwitchField label and track',
  },
  Table: {
    className: 'amplify-table',
    components: ['Table'],
    description: 'Top level element that wraps the Table primitive',
  },
  TableCaption: {
    className: 'amplify-table__caption',
    components: ['Table'],
    description: 'Class applied to the content provided as the caption prop',
  },
  TableBody: {
    className: 'amplify-table__body',
    components: ['Table'],
    description: 'Class applied to TableBody component',
  },
  TableTd: {
    className: 'amplify-table__td',
    components: ['Table'],
    description:
      'Class applied to TableCell component rendered as a <td> element (<TableCell as="td" />)',
  },
  TableTh: {
    className: 'amplify-table__th',
    components: ['Table'],
    description:
      'Class applied to TableCell comopnent rendered as a <th> element (<TableCell as="th" />)',
  },
  TableFoot: {
    className: 'amplify-table__foot',
    components: ['Table'],
    description: 'Class applied to TableFoot component',
  },
  TableHead: {
    className: 'amplify-table__head',
    components: ['Table'],
    description: 'Class applied to TableHead component',
  },
  TableRow: {
    className: 'amplify-table__row',
    components: ['Table'],
    description: 'Class applied to TableRow component',
  },
  Tabs: {
    className: 'amplify-tabs',
    components: ['Tabs'],
    description: 'Top level element that wraps the Tabs primitive',
  },
  TabItems: {
    className: 'amplify-tabs-item',
    components: ['Tabs'],
    description: 'Top level element that wraps the TabItem primitive',
  },
  Text: {
    className: 'amplify-text',
    components: ['Text'],
    description: 'Top level element that wraps the Text primitive',
  },
  Textarea: {
    className: 'amplify-textarea',
    components: ['TextAreaField'],
    description: 'Class applied to the text area',
  },
  TextAreaField: {
    className: 'amplify-textareafield',
    components: ['TextAreaField'],
    description: 'Top level element that wraps the TextAreaField primitive',
  },
  TextField: {
    className: 'amplify-textfield',
    components: ['TextField'],
    description: 'Top level element that wraps the TextField primitive',
  },
  ToggleButton: {
    className: 'amplify-togglebutton',
    components: ['ToggleButton'],
    description: 'Top level element that wraps the ToggleButton primitive',
  },
  ToggleButtonGroup: {
    className: 'amplify-togglebuttongroup',
    components: ['ToggleButton', 'ToggleButtonGroup'],
    description: 'Top level element that wraps the ToggleButtonGroup primitive',
  },
  VisuallyHidden: {
    className: 'amplify-visually-hidden',
    components: ['VisuallyHidden'],
    description: 'Top level element that wraps the VisuallyHidden primitive',
  },
};

type ComponentNames = keyof typeof ComponentClassObject;
let ComponentClassNames: { [Name in ComponentNames]?: string } = {};
Object.keys(ComponentClassObject).map((keyName) => {
  ComponentClassNames[keyName] = ComponentClassObject[keyName].className;
});
Object.freeze(ComponentClassNames);
export { ComponentClassNames };
